import { AdvanceStageSelect } from "@forwardflow/modals/MapStageModal/AdvanceStageSelect";
import { SelectField } from "@forwardflow/ui";
import Icon from "@forwardflow/ui/Icons";
import { useState } from "react";

export const NurtureStages = () => {
  const [edit, setEdit] = useState<boolean>(false);

  const [selectedStage, setSelectedStage] = useState<string>(
    "Default FUB updation"
  );
  return (
    <div className="flex justify-between px-10 py-5 bg-primary/10">
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center mt-3 font-medium text-white gap-x-4 mb-7">
            <Icon name="Nurture" />
            <span>Nurture Stages</span>
          </div>
          <div>
            {!edit ? (
              <button
                onClick={() => setEdit(true)}
                className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
              >
                Edit
              </button>
            ) : (
              <div className="flex gap-x-4">
                <button
                  onClick={() => setEdit(true)}
                  className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
                >
                  Reset
                </button>
                <button
                  onClick={() => setEdit(false)}
                  className={`h-10 font-medium rounded bg-primary hover:bg-primary-dark w-28 transition-all`}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>

        {edit && (
          <p className="border-b border-black/20 text-[12px] mb-7">
            <SelectField
              className="ff-inline-select-border-4 max-w-52"
              defaultValue={"Default FUB updation"}
              options={[
                {
                  label: "Default FUB updation",
                  value: "Default FUB updation",
                },
                {
                  label: "Organization default",
                  value: "Organization default",
                },
                {
                  label: "Advanced FUB matching",
                  value: "Advanced FUB matching",
                },
              ]}
              onChange={(value) => {
                setSelectedStage(value);
              }}
            ></SelectField>
          </p>
        )}
        <>
          {selectedStage === "Default FUB updation" ||
          selectedStage === "Organization default" ? (
            <>
              <p className="text-[14px] font-medium mb-4">{selectedStage}</p>
              <p className="text-[12px] text-[#D2D2D2] max-w-[584px] mb-6">
                Once While our system is working leads in your campaigns, we
                will move them all to a new stage created by us in FUB called
                Forward Flow Engaging
              </p>
            </>
          ) : (
            <>
              <div className="pb-3">
                <div className="flex items-center mb-4 gap-x-4">
                  <p className="text-[14px] text-white font-medium">
                    Advanced FUB matching
                  </p>
                </div>
                <p className="text-[12px] text-[#D2D2D2]">
                  Match stages fro your Follow Up Boss to Forward Flow Nurturing
                  stages
                </p>
                <div>
                  <div>
                    <div className="flex text-[#D2D2D2] gap-x-2 text-[12px] my-5">
                      <Icon name="Info" className="text-white" />
                      <span>
                        For the stages which we couldn’t find a match, we have
                        suggested you, new stages to be created in FUB. But you
                        can select another existing stage instead.
                      </span>
                    </div>
                    <div className="flex flex-col gap-y-1">
                      <AdvanceStageSelect
                        className="bg-[#3B4D35] rounded-lg"
                        title="Hot prospect"
                      >
                        <span
                          className={`w-4 h-4 flexc rounded-full bg-[#6ABE39]/40`}
                        >
                          <span
                            className={`bg-[#6ABE39] w-[10px] h-[10px] rounded-full`}
                          ></span>
                        </span>
                      </AdvanceStageSelect>
                      <AdvanceStageSelect
                        className="bg-[#544636] rounded-lg"
                        title="Warm prospect"
                      >
                        <span
                          className={`w-4 h-4 flexc rounded-full bg-[#8F6838]/40`}
                        >
                          <span
                            className={`bg-[#E89A3C] w-[10px] h-[10px] rounded-full`}
                          ></span>
                        </span>
                      </AdvanceStageSelect>
                      <AdvanceStageSelect
                        className="bg-[#51362F] rounded-lg"
                        title="Cold prospect"
                      >
                        <span
                          className={`w-4 h-4 flexc rounded-full bg-[#873E27]/40`}
                        >
                          <span
                            className={`bg-[#D84A1B] w-[10px] h-[10px] rounded-full`}
                          ></span>
                        </span>
                      </AdvanceStageSelect>
                      <AdvanceStageSelect
                        className="bg-[#472D31] rounded-lg"
                        title="Long term prospect"
                      >
                        <span
                          className={`w-4 h-4 flexc rounded-full bg-[#6D272B]/40`}
                        >
                          <span
                            className={`bg-[#A61D24] w-[10px] h-[10px] rounded-full`}
                          ></span>
                        </span>
                      </AdvanceStageSelect>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      </div>
    </div>
  );
};
